import axios from 'axios'
import utils from "./utils"
export default () => {
    return axios.create({
        baseURL: utils.getAPIUrl(),
    })
}